import {ProviderProps} from "../types/providerProps";
import {useLocationInitialization} from "../initialization/useLocationInitialization";
import {useInertiaNavigation} from "../initialization/useInertiaNavigation";

type Props = {
    providerProps: ProviderProps;
};

export const AppInitialization = ({providerProps}: Props) => {
    /**
     * События и лоадер при навигации от инертии
     */
    useInertiaNavigation();

    /**
     * Определение местоположения по IP-Адресу (Через сервис DaData) и инициализация локации
     */
    useLocationInitialization(providerProps.location);

    return null;
}
